module.exports = __webpack_public_path__ + "files/1092fe868a9a42cc879eb17408ca5dbe.png";